// styles/GlobalStyle.js or GlobalStyles.ts
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  p {
    font-size: ${(props) => props.theme.fontSizes.base};
    line-height: 1.5;
    letter-spacing: ${(props) => props.theme.letterSpacing.wide};
    margin: 0;
  }
  h1{
    font-size: ${(props) => props.theme.fontSizes.xxl};
  }
  h4{
    font-size: ${(props) => props.theme.fontSizes.md};
  }
`;
